import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DownloadSection from "@/components/DownloadSection";

const Downloads = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Check if mobile device
    const isMobile = /android|iphone|ipad|ipod/i.test(userAgent.toLowerCase());
    
    if (isMobile) {
      // Check if Android
      if (/android/i.test(userAgent.toLowerCase())) {
        window.location.href = "https://play.google.com/store/apps/details?id=ai.zuto.app";
      } 
      // Check if iOS
      else if (/iphone|ipad|ipod/i.test(userAgent.toLowerCase())) {
        window.location.href = "https://apps.apple.com/us/app/zuto-ai-assistant/id6752733945";
      }
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <DownloadSection />
      </main>
      <Footer />
    </div>
  );
};

export default Downloads; 